// extracted by mini-css-extract-plugin
export default {"root":"GA7lAJzl","small":"xIEIPxXe","medium":"QfMPUcDl","large":"B2srCgNz","pictogram":"tAYolXQT"};